module.exports = __webpack_public_path__ + "img/dots.ec76ec80.png";